import { PulseLoader } from 'react-spinners'

const Loader = ({ size }) => {
	return <PulseLoader size={size ? size : 12} color={'#4f31c5'} />
}

export default Loader
